var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1 1)"},[React.createElement("circle",{"data-name":"Ellipse 2","cx":"8","cy":"8","r":"8","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("line",{"data-name":"Ligne 2","x1":"4.35","y1":"4.35","transform":"translate(13.65 13.65)","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

Search.defaultProps = {"width":"20.414","height":"20.414","viewBox":"0 0 20.414 20.414"};

module.exports = Search;

Search.default = Search;
